module.exports = __webpack_public_path__ + "static/media/face-detection- (11).7d4a3eb9.jpg";